import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import getCauseCategoryById from '../../hooks/getCauseCategoryById';
import {app} from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const Editcausecategory = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [uploadLogo, setuploadLogo] = useState(true);
  const [imageUrl, setImageUrl] = useState();
  const [causeObj, setCauseObj] = useState({});
  let causeCategoryId=JSON.parse(localStorage.getItem('causeCategoryId'));
  let user=JSON.parse(localStorage.getItem('user'));
  console.log(user.userId);
  let causeCatResp=getCauseCategoryById(causeCategoryId);
  let causeCategoryObj=causeCatResp.response?causeCatResp.response.data:[];
  console.log(causeCategoryObj);
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
const token=getTokenfromUserObj()
const headers={auth:token};
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
      info.file?setUploadedImg(info.file.response.data.Location):" "
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setuploadLogo(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // console.log(causeCat[0].cause_category);
 
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/cause/causecat/update/${causeCategoryId}`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          navigate('/cause/categories');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
      setShow(false)
      if(err.response.status&&err.response.data.statusCode)message.error(err.response.data.data)
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  console.log(causeObj);

  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setCauseObj({
      causeCategory: values.causeCategory ? values.causeCategory : " ",
      displayPosition: values.displayPosition ? values.displayPosition : 0, 
      image:uploadedImg? uploadedImg:causeCategoryObj.image,
      isActive: values.isActive === true ? 1 : 0,
      updatedByUserId: user.userId

    });
    setShow(true);
  };
  console.log(causeObj);

  const submitData = () => {
    console.log('calling');
    if (Object.keys(causeObj).length > 0) {
      uploadData(causeObj);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    navigate('/cause/categories',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  return (
<div class='row mt-4 w-75 tbl'>
<div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
          
            <LeftCircleOutlined
              onClick={() => {
                navigate('/cause/categories');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Cause Catergory')} </h2>
          </div>{' '}
        </div>
            <div class="col-lg-11 mb-5 ">
            <div class='col-lg-9 align-self-center mt-2 mb-4 mt-4'>
           {causeCatResp.response ?<Form
                name='basic'
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                style={{
                  maxWidth: 600,
                }}
                initialValues={{
                  remember: true,
                  ['causeCategory']:causeCategoryObj.causeCategory,
                  ['displayPosition']:causeCategoryObj.displayPosition,
                  ['isActive']: causeCategoryObj.isActive===1?true:false,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item  
                  colon={false}
                  label='Cause Category'
                  name='causeCategory'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input maxLength={20}/>
                </Form.Item>
                <Form.Item
              colon={false}
              label='Display Position'
              name='displayPosition'
              rules={[
                {
                  required: false,
                  message: 'Enter display position',
                },
              ]}
            >
              <Input placeholder='Enter display position' min={1} type='number' maxLength={20} />
            </Form.Item>
                <Form.Item label='Image'   colon={false}  name='image'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}

              action={`${app.URL}/upload/causecatimage`}

              // action={`${app.URL}/api/upload/causecatimage`}

              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange}
            >
                {loading?uploadButton:(imageUrl?<img
                    src={imageUrl}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />: causeCategoryObj&&causeCategoryObj.image?<img src={causeCategoryObj.image}/>:" ")}
            </Upload>
          </Form.Item>
                <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                  <Switch />
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
                    {addUserResp.statusCode === 200 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : addUserResp.statusCode === 400 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Failed</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.data.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Are you sure you want to Update Cause Category?</Modal.Body>
                  <Modal.Footer>
                    <Button variant='secondary' onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button variant='primary' htmlType='submit' onClick={submitData}>
                      Save Changes
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                    Update
                  </button>
                </Form.Item>
              </Form>:" "}
            </div>
            </div>
          </div>
  );
};

export default Editcausecategory;
